(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ld-custom-product-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ld-custom-product-options')) {
  customElements.define('ld-custom-product-options', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.root = this.closest('product-info');
      this.variants = JSON.parse(this.querySelector('[data-custom-variants]').textContent);
      this.sizeStep = this.querySelector('[data-size-step]');
      this.packStep = this.querySelector('[data-pack-step]');
      this.formId = this.dataset.formId;
      this.custom = false;
      this.formats = [{key:'XS',w:5.5,h:5.5},{key:'S',w:10,h:10},{key:'M',w:8,h:11},{key:'L',w:11,h:18},{key:'Rękaw',w:16,h:47}];
      this.root.addEventListener('change', event => {
        if (event.target.matches('[data-size-choice]')) {
          this.custom = event.target.value === 'custom';
          this.setDimensionsState();
          if (this.custom) this.applyDimensions();
          else this.chooseNative('Rozmiar-2', event.target.value);
        } else if (event.target.matches('[data-pack-choice]')) {
          this.chooseNative('Pakiet-1', event.target.value);
        } else if (event.target.matches('[data-dimension]')) this.applyDimensions();
      });
      this.root.addEventListener('input', event => {if(event.target.matches('[data-dimension]')) this.applyDimensions();});
      this.root.addEventListener('click', event => {
        const button = event.target.closest('button[type=submit]');
        if(button && button.form?.id === this.formId) this.validateDimensions(event);
      }, true);
      document.getElementById(this.formId)?.addEventListener('submit', event => this.validateDimensions(event), true);
      window.addEventListener('click', event => {
        const button = event.target.closest('button[type=submit]');
        if(button?.form?.id !== this.formId) return;
        if(!this.purchaseReady()) {event.preventDefault();event.stopImmediatePropagation();this.validateDimensions(event);return;}
        const variant = this.variantFor(this.selectedNative('Rozmiar-2'));
        const input = button.form.querySelector('input[name=id]');
        if(input && input.value !== String(variant.id)) {input.value=variant.id;input.dispatchEvent(new Event('change',{bubbles:true}));}
      }, true);
      this.root.addEventListener('keydown', event => {
        if((event.key==='Enter'||event.key===' ') && event.target.matches('.po-fileUpload-uploadContent,.po-fileUpload-uploadRemove')) {
          event.preventDefault();event.target.click();
        }
      });
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(this.root, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
      this.refresh();
    }
    chooseNative(name, value) {
      const input = Array.from(this.root.querySelectorAll('variant-selects input[type=radio]')).find(e => e.name.trim() === name && e.value === value);
      if (input && !input.checked) input.click();
      this.updatePrices();
      this.syncPurchaseButton();
    }
    validateDimensions(event) {
      if(!this.custom) return;
      const invalid = Array.from(this.sizeStep.querySelectorAll('[data-dimension]')).find(input=>!input.checkValidity());
      if(invalid) {event.preventDefault();event.stopImmediatePropagation();invalid.reportValidity();}
    }
    setDimensionsState() {
      this.sizeStep.querySelector('[data-custom-dimensions]').hidden = !this.custom;
      this.sizeStep.querySelectorAll('[data-dimension]').forEach(input => {input.disabled = !this.custom;input.required = this.custom;if(!this.custom) input.setCustomValidity('');});
      this.syncPurchaseButton();
    }
    applyDimensions() {
      if (!this.custom) return;
      const wInput = this.sizeStep.querySelector('[data-dimension=width]');
      const hInput = this.sizeStep.querySelector('[data-dimension=height]');
      const w = Number(wInput.value), h = Number(hInput.value);
      wInput.setCustomValidity(''); hInput.setCustomValidity('');
      const match = this.formats.filter(f => w>=1 && h>=1 && ((w<=f.w && h<=f.h)||(h<=f.w && w<=f.h)))
        .sort((a,b)=>this.variantFor(a.key).price-this.variantFor(b.key).price)[0];
      const note = this.sizeStep.querySelector('[data-custom-price-note]');
      if (!match) {
        const message = 'Wpisz wymiary od 1 cm, mieszczące się w polu 16 × 47 cm (także po obróceniu).';
        if(wInput.value && hInput.value) hInput.setCustomValidity(message);
        note.textContent = message;
        this.syncPurchaseButton();
        return;
      }
      this.chooseNative('Rozmiar-2', match.key);
      const text = `Twój nadruk: ${w.toLocaleString('pl-PL')} × ${h.toLocaleString('pl-PL')} cm. Cena jak za format ${match.key}.`;
      if(note.textContent !== text) note.textContent = text;
      this.syncPurchaseButton();
    }
    purchaseReady() {
      if(this.custom && Array.from(this.sizeStep.querySelectorAll('[data-dimension]')).some(input=>!input.validity.valid)) return false;
      const expected = this.variantFor(this.selectedNative('Rozmiar-2'));
      const selected = this.root.querySelector('variant-selects [data-selected-variant]');
      if(!expected || !selected) return false;
      try {return JSON.parse(selected.textContent).id === expected.id;} catch {return false;}
    }
    syncPurchaseButton() {
      const button = document.getElementById(this.formId)?.querySelector('button[type=submit]');
      if(!button) return;
      if(!this.purchaseReady()) {this.blockedPurchase=true;if(!button.disabled) button.disabled=true;}
      else if(this.blockedPurchase && !button.classList.contains('loading')) {this.blockedPurchase=false;if(button.disabled) button.disabled=false;}
    }
    selectedNative(name) {return Array.from(this.root.querySelectorAll('variant-selects input[type=radio]:checked')).find(e => e.name.trim() === name)?.value;}
    variantFor(size, pack) {return this.variants.find(v=>v.option2===size && v.option1===(pack || this.selectedNative('Pakiet-1') || '10 sztuk'));}
    money(price) {return (price/100).toLocaleString('pl-PL',{style:'currency',currency:'PLN'});}
    updatePrices() {
      const size = this.selectedNative('Rozmiar-2') || 'XS';
      const pack = this.selectedNative('Pakiet-1') || '10 sztuk';
      this.packStep.querySelectorAll('[data-pack-price]').forEach(e=>{const v=this.variantFor(size,e.dataset.packPrice);const t=v?this.money(v.price):'';if(e.textContent!==t)e.textContent=t;});
      this.packStep.querySelectorAll('[data-pack-choice]').forEach(e=>e.checked=e.value===pack);
      if(!this.custom) this.sizeStep.querySelectorAll('[data-size-choice]').forEach(e=>e.checked=e.value===size);
    }
    refresh() {
      const upload = this.root.querySelector('.po-field-root input[type=file]');
      const appBlock = upload?.closest('.product-block--app');
      if(appBlock && this.nextElementSibling !== appBlock) appBlock.before(this);
      const consent = this.root.querySelector('.po-checkbox-root');
      if(consent && consent.previousElementSibling !== this.packStep) consent.before(this.packStep);
      this.updatePrices();
      this.syncPurchaseButton();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ld-pdp-hand-compare"] && !Shopify.designMode) return;
  try {
    (function() {
    if (customElements.get('ld-homepage-hand')) return;
    class LdHomepageHand extends HTMLElement {
      setup() {
  this.slider = this.querySelector('[data-slider]');
  if (!this.slider) return;

  this.afterContainer = this.querySelector('[data-after-container]');
  this.divider = this.querySelector('[data-divider]');
  this.handle = this.querySelector('[data-handle]');
  this.isDragging = false;
  this.isAnimating = false;
  this.currentPosition = 50;
  this.hasAutoPlayed = false;
  this.isMobile = window.matchMedia('(max-width: 749px)').matches;

  this.autoplayEnabled = this.dataset.autoplay === 'true';
  this.autoplayDuration = parseFloat(this.dataset.duration) * 1000;
  this.autoplayDelay = parseFloat(this.dataset.delay) * 1000;
  this.autoplayRepeat = parseInt(this.dataset.repeat);
}

      connectedCallback() {
        if (this.ready) return;
        this.setup();
        if (!this.slider) return;
        this.ready = true;

        this.updatePosition(this.currentPosition);
        this.setupEventListeners();

        if (this.autoplayEnabled && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.setupIntersectionObserver();
        }
      }

      setupIntersectionObserver() {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.hasAutoPlayed) {
              this.hasAutoPlayed = true;
              setTimeout(() => {
                this.runAutoplay();
              }, this.autoplayDelay);
            }
          });
        }, {
          threshold: 0.3
        });

        observer.observe(this.slider);
      }

      async runAutoplay() {
        this.isAnimating = true;
        this.slider.classList.add('is-animating');

        const sequence = [15, 85, 15, 50];
        const duration = this.autoplayDuration / sequence.length;

        for (let repeat = 0; repeat < this.autoplayRepeat; repeat++) {
          for (let i = 0; i < sequence.length; i++) {
            await this.animateToPosition(sequence[i], duration);
          }
        }

        this.isAnimating = false;
        this.slider.classList.remove('is-animating');
      }

      animateToPosition(targetPosition, duration) {
        return new Promise((resolve) => {
          const startPosition = this.currentPosition;
          const distance = targetPosition - startPosition;
          const startTime = performance.now();

          const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeProgress = this.easeInOutCubic(progress);
            const newPosition = startPosition + (distance * easeProgress);

            this.updatePosition(newPosition);

            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              this.currentPosition = targetPosition;
              resolve();
            }
          };

          requestAnimationFrame(animate);
        });
      }

      easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      setupEventListeners() {
  this.slider.addEventListener('mousedown', this.handleStart.bind(this));
  document.addEventListener('mousemove', this.handleMove.bind(this));
  document.addEventListener('mouseup', this.handleEnd.bind(this));
  this.slider.addEventListener('click', this.handleClick.bind(this));

  this.handle.addEventListener('touchstart', this.handleStart.bind(this), { passive: false });
  document.addEventListener('touchmove', this.handleMove.bind(this), { passive: false });
  document.addEventListener('touchend', this.handleEnd.bind(this));

  window.addEventListener('resize', () => {
    this.isMobile = window.matchMedia('(max-width: 749px)').matches;
  });
}

      handleStart(e) {
  if (this.isAnimating) return;

  if (this.isMobile) {
    const startedFromHandle = this.handle.contains(e.target);
    if (!startedFromHandle) return;

    e.preventDefault();
    this.isDragging = true;
    return;
  }

  this.isDragging = true;
  this.updatePositionFromEvent(e);
}

      handleMove(e) {
        if (!this.isDragging || this.isAnimating) return;
        e.preventDefault();
        this.updatePositionFromEvent(e);
      }

      handleEnd() {
        this.isDragging = false;
      }

      handleClick(e) {
  if (this.isAnimating) return;
  if (this.isMobile) return;

  this.updatePositionFromEvent(e);
}

      updatePositionFromEvent(e) {
        const rect = this.slider.getBoundingClientRect();
        const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        const x = clientX - rect.left;
        const percentage = (x / rect.width) * 100;
        const clampedPercentage = Math.max(0, Math.min(100, percentage));

        this.currentPosition = clampedPercentage;
        this.updatePosition(clampedPercentage);
      }

      updatePosition(percentage) {
        const clampedPercentage = Math.max(0, Math.min(100, percentage));

        this.afterContainer.style.clipPath = `inset(0 ${100 - clampedPercentage}% 0 0)`;
        this.divider.style.left = `${clampedPercentage}%`;
        this.handle.style.left = `${clampedPercentage}%`;
      }
    }

    customElements.define('ld-homepage-hand', LdHomepageHand);
  })();
  } catch(e) { console.error(e); }
})();

})();
